module.exports = __webpack_public_path__ + "img/pic6.4c8f0c7.png";